import i18n from '@/localization/i18n'

function getFolderMapTypicalPaths(): Record<string, string> {
    const value = i18n.global.tm('tooltips.folderMapTypicalPaths') as unknown
    if (value && typeof value === 'object' && !Array.isArray(value)) {
        return value as Record<string, string>
    }
    return {}
}

export function normalizeFolderMapName(name: string | null | undefined): string {
    if (!name) return ''
    const raw = String(name).trim()
    if (!raw) return ''

    const afterColon = raw.includes('::') ? raw.split('::').pop() ?? raw : raw
    const afterDot = afterColon.includes('.') ? afterColon.split('.').pop() ?? afterColon : afterColon
    return afterDot.trim()
}

export function getFolderMapTooltip(option: {
    label?: string
    mapPath?: string
    typicalPath?: string
} | null | undefined): string {
    if (!option) return ''

    if (option.typicalPath && option.typicalPath.trim()) {
        return option.typicalPath
    }

    const key = normalizeFolderMapName(option.label)
    const map = getFolderMapTypicalPaths()
    if (key && Object.prototype.hasOwnProperty.call(map, key)) {
        return map[key]
    }

    return option.mapPath || option.label || ''
}